import { FormikStringSchema, useClearOnUnmount, useFieldHelpers } from '@/base'
import { RadioGroup, RadioGroupProps } from '../../atoms/radio-group'
import { FormField, FormFieldProps } from '.'

export const FormRadioGroup = ({
  name,
  schema,
  shouldClearOnDismount,
  message,
  label,
  optionalText,
  description,
  ...rest
}: Omit<RadioGroupProps, 'value' | 'onChange'> &
  Omit<FormFieldProps, 'children'> & {
    schema?: FormikStringSchema
    shouldClearOnDismount?: boolean
  }) => {
  const { field, helpers } = useFieldHelpers({ name, schema })
  useClearOnUnmount(shouldClearOnDismount, helpers.setValue)

  return (
    <FormField
      name={name}
      label={label}
      schema={schema}
      message={message}
      description={description}
      optionalText={optionalText}
    >
      <RadioGroup
        value={field.value}
        onValueChange={(value) => helpers.setValue(value)}
        {...rest}
      />
    </FormField>
  )
}
